export default __webpack_public_path__ + "files/3ebc4d2c9a305b116e924407e50e8c2c.png";